var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"flex"},[_c('SideBar',{staticClass:"hidden lg:block"}),_c('div',{staticClass:"w-full bg-bgGrey"},[_c('NavBar'),_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }